import { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { SmartBannerContext } from 'contexts/SmartBannerContext'
import { respondAbove } from 'styles/mixins'
import { useStores } from 'hooks/useStores'
import StoresDialogBoxContent from 'components/home/ModalContent/StoresDialogBoxContent'
import { geoCode } from 'utils/googleMapsUtils/googleMapsUtils'
import lookupCountry from 'country-code-lookup'
import type _Home from 'mobx/Home'
import { inject } from 'mobx-react'
import { injectStores } from 'mobx/injection'
import googlePlacesCallbackHandler from 'components/home/ModalContent/googlePlacesCallbackHandler'

const Container = styled.div<{ smartBannerIsShown: boolean }>`
	height: 100dvh;
	padding-bottom: 23px;
	margin-top: ${(props) => (props.smartBannerIsShown ? '80px' : 'unset')};

	${respondAbove.lg`
        height: calc(43vh + 48px);
        min-height: 498px;
        margin-top: unset;
	`}
`

const StoreOnMapSelection = () => {
	const { localizationStore, addressManagerV2Store } = useStores()
	const [googlePlacesReady, setGooglePlacesReady] = useState(!!localizationStore.processingFlow?.address)
	const smartBannerContext = useContext(SmartBannerContext)

	useEffect(() => {
		const init = async () => {
			let googlePlaceData = {}
			if (localizationStore.processingFlow?.address) {
				googlePlaceData = {
					formatted: localizationStore.processingFlow?.address.formatted,
					lat: localizationStore.processingFlow?.address.location.lat,
					lng: localizationStore.processingFlow?.address.location.lng,
				}

				localizationStore.processingFlow.setOrderTypeFlowDisplayAvailableStores(true)
			}

			await googlePlacesCallbackHandler(googlePlaceData, undefined, addressManagerV2Store)
			setGooglePlacesReady(true)
		}

		init()
	}, [])

	return (
		<Container smartBannerIsShown={smartBannerContext.isShown}>
			<StoresDialogBoxContent loading={!googlePlacesReady} />
		</Container>
	)
}

export default StoreOnMapSelection
